import React from 'react';
import './AnnouncementBar.css';

const AnnouncementBar = () => {
  return (
    <div className="announcement-bar">
      LIMITED: Test us for FREE! Get a free 1-week-key:  <a href="https://eaglescript.space:5989/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'underline', color: 'black'}}>Join Discord</a>
    </div>
  );
};

export default AnnouncementBar;